import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { StorageCleanupService } from '@core/auth/storage-cleanup.service';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
    imports    : [RouterOutlet],
})
export class AppComponent
{
    /**
     * Constructor
     */
    constructor(private _storageCleanup: StorageCleanupService)
    {
        this._storageCleanup.cleanStorage();
    }
}
